// Returns the element's distance from the top/left-most point of the document.
// .. To access the top, do getElementPosition(el).top
export default function getElementPosition(el) {
  const rect = el.getBoundingClientRect()
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY,
  }
}
